function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.8333333,-3.0375702e-13 L10.8333333,1.66666667 L4.16666667,1.66666667 L4.16666667,-3.0375702e-13 L2.5,-3.0375702e-13 L2.5,1.66666667 L1.66666667,1.66666667 C0.741666667,1.66666667 0.00833333333,2.41666667 0.00833333333,3.33333333 L0,15 C0,15.9166667 0.741666667,16.6666667 1.66666667,16.6666667 L13.3333333,16.6666667 C14.25,16.6666667 15,15.9166667 15,15 L15,3.33333333 C15,2.41666667 14.25,1.66666667 13.3333333,1.66666667 L12.5,1.66666667 L12.5,-3.0375702e-13 L10.8333333,-3.0375702e-13 L10.8333333,-3.0375702e-13 Z M13.3333333,15 L1.66666667,15 L1.66666667,5.83333333 L13.3333333,5.83333333 L13.3333333,15 L13.3333333,15 Z",
  id: "path-1"
});
const SvgEvents = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 17,
  viewBox: "0 0 15 17",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEvents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/events.5302eb0e.svg";
export { ForwardRef as ReactComponent };